import React, { useState, useEffect } from "react";
import './subscription.css';
import SubscriptionItem from './SubscriptionItem'
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import { get, post } from '../../util/axiosConfig/AxiosConfig'
import MockItem from "./MockItem";
import { useParams } from "react-router-dom";
import CombineItem from "./CombineItem";


const Subscription = () => {
    const { courseId } = useParams();

    const [loading, setLoading] = useState(false);
    const [subscriptionPlan, setSubscriptionPlan] = useState([]);
    const [featuresList, setFeaturesList] = useState([]);
    const [mockList, setMockList] = useState([])
    const [comboList, setComboList] = useState([])
    const [features, setFeatures] = useState([]);
    const [active, setActive] = useState([]);
    const [filter, setFilter] = useState('all');
    const [courseName, setCourseName] = useState("")
    const [courseType, setCourseType] = useState("")


    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
    }, [filter]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await get(`web/api/v1/lms-web/open/get-subscription-details/${courseId}/${filter}`);
            //web/api/v1/lms-web/open/get-subscription-details/4/all
            setCourseName(response.courseName)
            setCourseType(response.courseTypeName)

            if (filter == 'subscription') {
                setSubscriptionPlan(response.subscriptionPlan);
                setFeaturesList(response.planFeatureList);
                response.planFeatureList.map((item, index) => {
                    setFeatures(Object.keys(item.description))
                })
                setActive(Object.values(response.planFeatureList[0].description))
            }
            else if (filter == 'mock') {
                setMockList(response.mockPlan)
                // setFeaturesList(response.planFeatureList);
                // response.planFeatureList.map((item, index) => {
                //     setFeatures(Object.keys(item.description))
                // })
                // setActive(Object.values(response.planFeatureList[0].description))
            }
            else if (filter == 'combo') {
                setComboList(response.comboPlan)
                setFeaturesList(response.planFeatureList);
                response.planFeatureList.map((item, index) => {
                    setFeatures(Object.keys(item.description))
                })
                setActive(Object.values(response.planFeatureList[0].description))
            } else {
                setSubscriptionPlan(response.subscriptionPlan);
                setFeaturesList(response.planFeatureList);
                setMockList(response.mockPlan)
                setComboList(response.comboPlan)
                response.planFeatureList.map((item, index) => {
                    setFeatures(Object.keys(item.description))
                })
                setActive(Object.values(response.planFeatureList[0].description))
            }

            // setActive1(Object.values(response.planFeatureList[1].description))
            // setActive2(Object.values(response.planFeatureList[2].description))
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };



    // const sendData = async () => {
    //     const data = {
    //         "userId": 1,
    //         "id": 1,
    //         "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
    //         "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
    //     };

    //     try {
    //         const response = await post('/posts', data);
    //         setLoading(true);
    //         console.log(response);
    //     } catch (error) {
    //         setLoading(false);
    //         console.error(error);
    //     }
    // };


    const subscriptionData = [
        {
            type: "Silver",
            amount: 599,
            features: [
                { text: "15 Days Duration", status: "active" },
                { text: "Online Mode", status: "active" },
                { text: "Study At Your Ease", status: "active" },
                { text: "Question Banks Available", status: "active" },
                { text: "Case Studies Available", status: "inactive" }
            ]
        },
        {
            type: "Gold",
            amount: 799,
            features: [
                { text: "60 Days Duration", status: "active" },
                { text: "Online Mode", status: "active" },
                { text: "16 Hours Online Sessions", status: "active" },
                { text: "Question Banks Available (500)", status: "active" },
                { text: "Case Studies Available", status: "active" },
            ]
        },
        {
            type: "Platinum",
            amount: 999,
            features: [
                { text: "60 Days Duration", status: "active" },
                { text: "Online Mode", status: "active" },
                { text: "16 Hours Online Sessions", status: "active" },
                { text: "Question Banks Available (500)", status: "active" },
                { text: "Case Studies Available", status: "active" },
            ]
        },
    ]


    // Table data
    const TableData = [
        {
            feature: "15 Days Duration",
            plans: [false, true, true, false, true, false]
        },
        {
            feature: "Online Mode",
            plans: [true, false, true, true, true, false]
        },
        {
            feature: "Question Banks Available",
            plans: [true, true, false, true, true, false]
        },
        {
            feature: "Case Studies Available",
            plans: [true, true, true, false, true, false]
        },
        {
            feature: "Study At Your Ease",
            plans: [true, true, true, true, true, true]
        },
    ];

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };


    return (
        <React.Fragment>
            <Header />
            <div className="subscription_main">
                {/* <div className="course_banner_sectioon">
                    <div className="page_banner_inner" >
                        <div className="container">
                            <div className="banner_text">
                                <h4 className="banner_course_title">There of Lorem Ipsum available</h4>
                                <p className="banner_course_description">
                                    The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS).
                                </p>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div className="filter_sec">
                    <select id="filter" value={filter} onChange={handleFilterChange} className="planFilter">
                        <option value="all">All</option>
                        <option value="subscription">Subscription Plan</option>
                        <option value="mock">Mock Exam</option>
                        <option value="combo">Combo Plan</option>
                    </select>
                </div> */}
                <div className="container">
                <p className="subscription_item_title_desc">{courseName}</p>
                    {
                     subscriptionPlan.length != 0  && (filter === 'subscription' || filter === 'all')  ?
                            <>
                                <div className="subscription_item_header">
                                    {/* <p className="subscription_item_title_desc">Best Plans For XXI-A PMS Distributor</p> */}
                                    
                                    <h4 className="subscription_item_main_title">{courseType == "Short" ? "" : "Choose Your Subscription Plan"}</h4>
                                </div>
                                <div className="row design_item">
                                    {subscriptionPlan.map((items, index) => (
                                        <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                            <SubscriptionItem id={items.id} type={items.name} amount={items.price} features={items.descriptionsObj} validity={items.time} shortCourse = {courseType} />
                                        </div>
                                    ))}
                                </div>
                            </>
                            :
                            ''
                    }


                    {/* Mock section */}

                    {
                       mockList.length != 0  && (filter === 'mock' || filter === 'all') ?
                            <>
                                <div className="mock_plan_features">
                                    <div className="mock_features_title">
                                        {/* <p className="subscription_item_title_desc">Best Plans For XXI-A PMS Distributor</p> */}
                                        <h4 className="subscription_item_main_title">Mock Test Plan</h4>
                                    </div>
                                    <div className="row design_item">
                                        {mockList.map((items, index) => (
                                            <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                {/* <MockItem id={items.id} type={items.name} amount={items.price} feature={items.description} /> */}
                                                <MockItem id={items.id} type={items.name} amount={items.price} features={items.descriptions} validity={items.time} mockData={items} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                            : ''
                    }


{
comboList.length != 0  && (filter === 'combo' || filter === 'all') ?
<>
                            <div className="mock_plan_features">
                                    <div className="mock_features_title">
                                        {/* <p className="subscription_item_title_desc">Best Plans For XXI-A PMS Distributor</p> */}
                                        <h4 className="subscription_item_main_title">Combo Plan</h4>
                                    </div>
                                    <div className="row design_item">
                                        {comboList.map((items, index) => (
                                            <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                <CombineItem id={items.id} type={items.name} amount={items.price} features={items.descriptions} validity={items.time}  mock={items.mockPlan} subscription={items.subscriptionPlan}/>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                </> : ''
}



                    {/* Plan features */}
                    {comboList.length === 0 && subscriptionPlan.length === 0 ? null :
                    <div className="subscription_plan_features">
                        <div className="plan_features_title">
                            <h4>Features</h4>
                        </div>
                        <div className="tablewrapper">
                            <div className="">
                                <table className="featuretable">
                                    <thead>
                                        <th className="feature_th1" scope="col">Features</th>
                                        {featuresList.map((items, index) => (
                                            <th key={index} className="feature_th" scope="col">{items.planName}</th>
                                        ))}

                                        {/* <tr>
                                            <th scope="col">Features</th>
                                            <th scope="col">Plan 1</th>
                                            <th scope="col">Plan 2</th>
                                            <th scope="col">Plan 3</th>
                                            <th scope="col">Plan 4</th>
                                            <th scope="col">Plan 5</th>
                                            <th scope="col">Plan 6</th>
                                        </tr> */}
                                        <tr>
                                            {/* {object.map((status, planIndex) => (
                                                    <th scope="col" key={planIndex}>
                                                        <span className={`tick_icon_black ${status ? 'tick_icon' : 'text-danger'}`}>
                                                            <i className={`fa-regular ${status ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                        </span>
                                                    </th>
                                                ))} */}
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {/* {TableData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.feature}</td>
                                                {item.plans.map((status, planIndex) => (
                                                    <td key={planIndex}>
                                                        <span className={`tick_icon_black ${status ? 'tick_icon' : 'text-danger'}`}>
                                                            <i className={`fa-regular ${status ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                        </span>
                                                    </td>
                                                ))}
                                            </tr>
                                        ))} */}
                                        <tr>
                                            {featuresList.map((plan, index) => (
                                                <>
                                                    <td className={index == 0 ? "d-block" : "d-none"}>
                                                        {Object.entries(plan.description).map(([feature, value]) => (
                                                            <p className="featurename">{feature}</p>
                                                        ))}
                                                    </td>

                                                    <td>
                                                        {Object.entries(plan.description).map(([feature, value]) => (
                                                            <p key={feature} className={`tick_icon_black plan_details ${value ? 'tick_icon featureavl' : 'xmark_icon featurenotavl'}`}>  <i className={`fa-regular ${value ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i></p>
                                                        ))}
                                                    </td>
                                                </>

                                            ))}


                                            {/* 
                                            
                                            <React.Fragment key={index}>
                                                <td className={index === 0 ? "d-block" : "d-none"}>
                                                    {Object.entries(plan.description).map(([feature, value]) => (
                                                        <p key={`${index}-${feature}`} className="featurename">{feature}</p>
                                                    ))}
                                                </td>
                                                <td>
                                                    {Object.entries(plan.description).map(([feature, value]) => (
                                                        <p key={`${index}-${feature}-value`} className={`tick_icon_black plan_details ${value ? 'tick_icon featureavl' : 'xmark_icon featurenotavl'}`}>
                                                            <i className={`fa-regular ${value ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                        </p>
                                                    ))}
                                                </td>
                                            </React.Fragment>
                                            
                                            
                                             */}
                                        </tr>
                                        {/* <tr >
               
                                            {master.map((plan, index) => (
                                                <>
                                            
                                                <td   className={index == 0 ? "d-block":"d-none"}>
                                                {Object.entries(plan.description).map(([feature, value]) => (
                                                
                                                <><p className="featurename">{feature}</p></>
                                                ))}
                                            </td>
                                            <td  >
                                                
                                                {Object.entries(plan.description).map(([feature, value]) => (
                                                
                                                <><p key={feature}className={value?"featureavl":"featurenotavl"}>      {value ? "L" : "X"}  </p></>
                                                ))}
                                            
                                            </td></>
                                                
                                            ))}
                                         </tr> */}


                                        {/* {features.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item}</td>
                                               
                                                    
                                                     {active.map((plan, planIndex) => (
                                                         <td key={planIndex}>
                                                        <span className={`tick_icon_black ${plan ? 'tick_icon' : 'text-danger'}`}>
                                                            <i className={`fa-regular ${plan ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                        </span>
                                                    </td>
                                                     ))} 
                                                     
                                    
                                                  
                                                   
                                               
                                            </tr>
                                        ))}       */}



                                        {/* {featuresList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.planName}</td>
                                                {featuresList.map((plan, planIndex) => (
                                                    <td key={planIndex}>
                                                        <span className={`tick_icon_black ${plan.description[item.feature] ? 'tick_icon' : 'text-danger'}`}>
                                                            <i className={`fa-regular ${plan.description[item.feature] ? 'fa-circle-check' : 'fa-circle-xmark'}`}></i>
                                                        </span>
                                                    </td>
                                                ))}
                                            </tr>
                                        ))} */}


                                        {/* <tr>
                                            <td>15 Days Duration</td>
                                            <td><span className="tick_icon_black tick_icon"><i class="fa-regular fa-circle-check"></i></span></td>
                                            <td><span className="tick_icon_black tick_icon"><i class="fa-regular fa-circle-check"></i></span></td>
                                            <td><span className="tick_icon_black tick_icon"><i class="fa-regular fa-circle-check"></i></span></td>
                                            <td><span className="tick_icon_black text-danger"><i class="fa-regular fa-circle-xmark"></i></span></td>
                                            <td><span className="tick_icon_black tick_icon"><i class="fa-regular fa-circle-check"></i></span></td>
                                            <td><span className="tick_icon_black text-danger"><i class="fa-regular fa-circle-xmark"></i></span></td>
                                        </tr>*/}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            <Footer />
        </React.Fragment>
    )
}

export default Subscription;